

export const userColumn = [
    {
        label: "first_name",
        attr: "first_name",
        type: 1,
        editor: true
    },
    {
        label: "last_name",
        attr: "last_name",
        type: 1,
        editor: true
    },
    {
        label: "client_code",
        attr: "client_code",
        type: 1
    },
    {
        label: "phone",
        attr: "phone",
        type: 1,
        editor: true
    },
    {
        attr: "pickup_name",
        label: "ПВЗ",
        type: 3,
        opt: 12,
        hidden: false,
        editor: false
    },
    {
        attr: "package_shoes",
        label: "Переупаковка обуви",
        hidden: false,
        editor: false,
        body: (row) => {
            return (
                <input
                    type="checkbox"
                    checked={!row.package_shoes}
                    style={{ margin: 0 }}
                    readOnly
                />
            );
        }
    },
    {
        attr: "bag_package",
        label: "Переупаковка сумки",
        hidden: false,
        editor: false,
        body: (row) => {
            return (
                <input
                    type="checkbox"
                    checked={!row.bag_package}
                    style={{ margin: 0 }}
                    readOnly
                />
            );
        }
    },
    {
        label: "is_verified",
        attr: "is_verified",
        type: 1,
        editor: true
    },
    {
        label: "email",
        attr: "email",
        type: 1,
        editor: true
    },
    {
        label: "address",
        attr: "address",
        type: 1,
        editor: true
    },
    {
        label: "ppt_inn",
        attr: "ppt_inn",
        type: 1,
        editor: true
    },
    {
        label: "created_date",
        attr: "created_date",
        type: 4,
        editor: true,
        body: (rowData) =>
            formatDateUTC(rowData.created_date)
    },
    {
        label: "password",
        attr: "password",
        type: 1,
        hidden: false,
        editor: true,
        filter: true
    }
];

export const userForWareColumn = [
    {
        label: "first_name", attr: "first_name", type: 1,
        editor: true
    },
    {
        label: "last_name", attr: "last_name", type: 1,
        editor: true
    },
    { label: "client_code", attr: "client_code", type: 1 }
];

export function formatDateUTC(dateStr) {
    const date = new Date(dateStr);

    const dd = String(date.getUTCDate()).padStart(2, '0');
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0'); // месяцы от 0
    const yyyy = date.getUTCFullYear();

    const hh = String(date.getUTCHours()).padStart(2, '0');
    const min = String(date.getUTCMinutes()).padStart(2, '0');
    const ss = String(date.getUTCSeconds()).padStart(2, '0');

    return `${dd}.${mm}.${yyyy}, ${hh}:${min}:${ss}`;
}
export const userMessageColumn = [
    { label: "Номер", attr: "phone", type: 1 },
    { label: "Собщение", attr: "massage", type: 1 },
    {
        label: "Дата отправки", attr: "created_date", type: 1, body: (data) => {
            return formatDateUTC(data.created_date)
        }
    },
    { label: "Статус", attr: "status", type: 1 }
];


export const employeeColumn = [
    {
        label: "fio",
        attr: "fio",
        type: 1,
        editor: true,
        filter: true,
    },
    {
        label: "email",
        attr: "email",
        type: 1,
        editor: true,
        filter: true,
    },
    {
        label: "login",
        attr: "login",
        type: 1,
        editor: true,
        filter: true,
    },
    {
        label: "password",
        attr: "password",
        type: 1,
        editor: true,
        filter: true,
    },
    {
        label: "role",
        attr: "role",
        type: 4,
        editor: false,
        filter: true,
    },
    {
        label: "role_guid",
        attr: "role_guid",
        type: 3,
        opt: 10,
        optionLabel: "role",
        hidden: true,
        editor: true,
        filter: true,
    }
]
